{
  "created_by": "Erstellt von",
  "created": "Erstellt",
  "filter": "Filter",
  "example": {
    "test": "Mein Name ist {{ name }} und ich bin {{ age }} Jahre alt"
  },
  "buttons": {
    "cancel": "Stornieren",
    "save": "Speichern",
    "save_changes": "Änderungen speichern",
    "next": "Als Nächstes",
    "continue": "Fortfahren",
    "close": "Schliessen",
    "selectValue": "Wählen Sie {{ value }}",
    "remove": "Entfernen",
    "confirm": "Bestätigen",
    "saveAndFinish": "Speichern und fertig",
    "saveAndClose": "Speichern und schließen",
    "back": "Zurück",
    "copyValue": "Wert kopieren",
    "pasteValue": "Wert einfügen",
    "delete": "Löschen",
    "deleting": "Löschen",
    "deleteAll": "Alles löschen",
    "undo": "Rückgängig machen",
    "redo": "Erneut",
    "import": "Importieren",
    "export": "Exportieren",
    "add": "Hinzufügen",
    "share": "Teilen",
    "key": "Schlüssel",
    "create": "Erstellen",
    "expand": "Erweitern",
    "collapse": "Zusammenbruch",
    "select": "Wählen Sie",
    "select_all": "Alles auswählen",
    "upload": "Upload",
    "download": "Herunterladen",
    "add_another_item": "Einen weiteren Artikel hinzufügen",
    "move": "Bewegen",
    "edit": "Bearbeiten",
    "edit_name": "Namen bearbeiten",
    "removeImage": "Bild entfernen",
    "finish": "Fertig",
    "click_to_edit": "Klicken Sie hier, um {{ name }} zu bearbeiten",
    "click_to_select": "Klicken Sie, um {{ name }} auszuwählen",
    "click_to_deselect": "Klicken Sie hier, um die Auswahl von {{ name }} aufzuheben",
    "see_all": "Alles ansehen",
    "skip": "Überspringen",
    "submit": "Abschicken",
    "support": "Support kontaktieren",
    "upgrade": "Aufrüsten",
    "createLayer": "Ebene erstellen",
    "disable": "Deaktiviert",
    "enable": "Aktiviere",
    "copy": "Kopieren",
    "maximise": "Maximieren",
    "minimise": "Minimieren",
    "retry": "Erneut versuchen"
  },
  "toasts": {
    "creating_resource": "{{ resource }} wird erstellt. Wir sagen dir, wenn es fertig ist",
    "creation_completed": "Die Erstellung für {{ resource }} ist abgeschlossen",
    "resource_complete": "{{ resource }} abgeschlossen"
  },
  "selected": "Ausgewählt {{ selectedNumber }}",
  "no_children_available": "Kein {{ childType }} verfügbar",
  "loading...": "Wird geladen...",
  "saving": "Wird gespeichert",
  "pending_save": "Ausstehender Speichervorgang",
  "saved": "Gespeichert",
  "creating": "Erstellen",
  "errorLoading": "Fehler beim Laden von {{ resourceName }}",
  "yes": "Ja",
  "no": "Nein",
  "none": "Keine",
  "selection": {
    "none_selected": "Keine ausgewählt",
    "all_selected": "Alles ausgewählt",
    "selected": "Ausgewählt"
  },
  "upload": {
    "select_csv": "Wählen Sie eine CSV-Datei",
    "change_csv": "CSV-Datei ändern",
    "upload_errors_placeholder": "Wenn es Probleme mit Ihrer Datei gibt, werden sie hier angezeigt",
    "import_complete": "Der Import wurde erfolgreich abgeschlossen"
  },
  "sort": {
    "most_relevant": "Am relevantesten"
  },
  "settings": "Einstellungen",
  "no_results": "Keine Ergebnisse",
  "name": "Name",
  "in_development": "[In Entwicklung]",
  "exports": {
    "success_message": "{{ exportName }} wurde erfolgreich exportiert. Klicken Sie auf den Link, um ihn herunterzuladen",
    "error_message": "{{ exportName }} konnte nicht exportiert werden. Bitte versuchen Sie es später erneut oder wenden Sie sich an den Iventis-Support.",
    "start_message": "Der {{ exportName }} Export hat begonnen. Wir werden Sie informieren, wenn er fertig ist"
  },
  "all": "Alles",
  "copied_to_clipboard": "In die Zwischenablage kopiert",
  "click_for_details": {
    "whole": "Klicken Sie hier für weitere Informationen",
    "click": "Klicken Sie",
    "for_more": "für weitere Einzelheiten"
  },
  "here": "hier",
  "delete_confirmation_message": "Bist du sicher, dass du {{ entity }} löschen möchtest",
  "unavailable": "Nicht verfügbar",
  "link": "Link",
  "powered_by": "Bereitgestellt von",
  "boolean": {
    "true": "Stimmt",
    "false": "Falsch"
  },
  "delete": "Löschen",
  "learnMore": "Erfahre mehr",
  "items": "Artikel",
  "csv": "csv",
  "success": "Erfolg",
  "alert": "Warnung",
  "warning": "Warnung",
  "error": "Fehler"
}